<script setup lang="ts">
import { useAiChatStore } from '@/stores/aiChat'
import { Plus, Trash2, MessageSquare } from 'lucide-vue-next'

const aiStore = useAiChatStore()

function startNew() {
  aiStore.selectedConversationId = null
  aiStore.messages = []
}

function formatTime(dateStr: string) {
  const date = new Date(dateStr)
  const now = new Date()
  const diffMs = now.getTime() - date.getTime()
  const diffMins = Math.floor(diffMs / 60000)

  if (diffMins < 1) return 'now'
  if (diffMins < 60) return `${diffMins}m`
  const diffHours = Math.floor(diffMins / 60)
  if (diffHours < 24) return `${diffHours}h`
  const diffDays = Math.floor(diffHours / 24)
  if (diffDays < 7) return `${diffDays}d`
  return date.toLocaleDateString('en-US', { month: 'short', day: 'numeric' })
}
</script>

<template>
  <div class="flex flex-col h-full">
    <!-- New Chat button -->
    <div class="p-2 border-b border-surface-700">
      <button
        @click="startNew"
        class="w-full flex items-center gap-1.5 px-2 py-1.5 text-xs font-medium text-violet-400 hover:bg-surface-700 rounded transition-colors"
      >
        <Plus class="w-3.5 h-3.5" />
        New Chat
      </button>
    </div>

    <!-- Conversation list -->
    <div class="flex-1 overflow-y-auto">
      <div v-if="aiStore.loading" class="p-3 text-xs text-surface-500 text-center">Loading...</div>
      <div v-else-if="aiStore.conversations.length === 0" class="p-3 text-xs text-surface-500 text-center">No conversations yet</div>

      <button
        v-for="conv in aiStore.conversations"
        :key="conv.id"
        @click="aiStore.selectConversation(conv.id)"
        class="w-full text-left px-2 py-2 border-b border-surface-800 hover:bg-surface-750 transition-colors group"
        :class="aiStore.selectedConversationId === conv.id ? 'bg-surface-700' : ''"
      >
        <div class="flex items-start gap-1.5">
          <MessageSquare class="w-3 h-3 mt-0.5 text-surface-500 flex-shrink-0" />
          <div class="min-w-0 flex-1">
            <p class="text-xs text-surface-200 truncate">{{ conv.title }}</p>
            <p class="text-[10px] text-surface-500">{{ formatTime(conv.updated_at) }}</p>
          </div>
          <button
            @click.stop="aiStore.deleteConversation(conv.id)"
            class="opacity-0 group-hover:opacity-100 p-0.5 text-surface-500 hover:text-danger-400 transition-all"
            title="Delete"
          >
            <Trash2 class="w-3 h-3" />
          </button>
        </div>
      </button>
    </div>
  </div>
</template>
